import requirementsSelector from '../../AppointmentRequirementsSelector';
import { OBGYNConfirmationView } from './OBGYNConfirmationView';
import {
    clickCheckbox,
    trackClickObgynWarning,
} from './OBGYNConfirmationActions';
import { connect } from 'react-redux';
import { OBGYN_CONFIRMATION_STATE_KEY } from '../../constants';

export function mapStateToProps(state) {
    const requirements = requirementsSelector(state);
    return {
        isChecked: requirements[OBGYN_CONFIRMATION_STATE_KEY].value,
        invalidMessage: requirements[OBGYN_CONFIRMATION_STATE_KEY].error,
    };
}

export const mapDispatchToProps = {
    onCheck: clickCheckbox,
    trackClickObgynWarning,
};

export const OBGYNConfirmationConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(OBGYNConfirmationView);
